import React, { useEffect, useState } from 'react';
// import Img from 'react-image';
import ReactSound from 'react-sound';
// import styled from 'styled-components';
import ApngComponent from 'react-apng';

const AnimationWithSound = ({
  imageUrl,
  soundFile,
  playSound,
  onSoundEnd,
  imageLeft,
  imageTop,
  imageBottom,
  imageRight,
  imageWidth = '100%',
  imageHeight = '100%',
  onClick,
  zIndex,
  style,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  // Preload image and sound
  useEffect(() => {
    const preloadAssets = async () => {
      const promises = [];

      // Preload image
      if (imageUrl) {
        const imgPromise = new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = resolve;
          img.onerror = reject;
          img.src = imageUrl;
        });
        promises.push(imgPromise);
      }

      // Preload sound
      if (soundFile) {
        const audioPromise = new Promise((resolve, reject) => {
          const audio = new Audio();
          audio.oncanplaythrough = resolve;
          audio.onerror = reject;
          audio.src = soundFile;
          audio.muted = true; // Mute to allow autoplay
        });
        promises.push(audioPromise);
      }

      try {
        await Promise.all(promises);
        setIsLoaded(true);
      } catch (error) {
        console.error('Error preloading assets:', error);
        // Set loaded anyway to show content even if preload fails
        setIsLoaded(true);
      }
    };

    preloadAssets();
  }, [imageUrl, soundFile]);

  // console.debug('AnimationWithSound render', {
  //   imageUrl,
  //   soundFile,
  //   playSound,
  // });

  if (!isLoaded) {
    return null; // or return a loading spinner
  }

  return (
    <>
      <ApngComponent
        // ref={apngRef}
        src={imageUrl}
        autoPlay={true} // Disable default autoplay
        style={{
          width: imageWidth,
          height: imageHeight,
          position: 'absolute',
          top: imageTop,
          left: imageLeft,
          bottom: imageBottom,
          right: imageRight,
          zIndex: zIndex,
          ...style,
        }}
        onClick={() => {
          if (onClick) onClick();
        }}
      />
      <ReactSound
        url={soundFile}
        volume={playSound ? 100 : 0}
        playStatus="PLAYING"
        loop={false}
        onFinishedPlaying={() => {
          if (onSoundEnd) onSoundEnd();
        }}
      ></ReactSound>
    </>
  );
};

export default AnimationWithSound;
